<div class="row">
  <div class="col" style="padding-top:20px">
    <!-- <p>{{dict[item.typename]}}</p> -->
    <p>{{item.title}}</p>
  </div>
</div>
